const userDietTerms = {
  get: 'UserDietTerm/getlist-by-admin',
  add: 'UserDietTerm/add',
  update: 'UserDietTerm/update',
}
export default userDietTerms
